import type { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { getPaletteAsRawColors } from 'owa-theme';
import type { IButtonStyles } from '@fluentui/react/lib/Button';

export default function getCalendarThemedButtonStyle(
    colorScheme: ColorScheme,
    isDarkMode?: boolean
): IButtonStyles {
    let optionalButtonStyles: IButtonStyles = {
        root: {
            backgroundColor: getPaletteAsRawColors(null, isDarkMode).white,
            color: colorScheme.accessibleText.msColorWhiteBackground,
        },

        rootHovered: {
            backgroundColor: colorScheme.calLighter,
            color: colorScheme.calDark,
        },

        rootPressed: {
            backgroundColor: colorScheme.calLighter,
            color: colorScheme.calDarker,
        },

        rootExpanded: {
            backgroundColor: colorScheme.calLighter,
            color: colorScheme.calDarker,
        },
    };

    return optionalButtonStyles;
}
